import React, { forwardRef } from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  onClick,
  type = 'button',
  className = ''
}, ref) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-xl font-medium transition-[color,background-color,border-color,box-shadow] duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-primary-600 focus-visible:ring-offset-2';
  const variantClasses = {
    primary: 'border-2 border-primary-700 bg-primary-700 text-white hover:border-primary-800 hover:bg-primary-800 hover:text-white',
    secondary: 'border-2 border-primary-600 bg-transparent text-primary-600 hover:border-primary-700 hover:bg-primary-50 hover:text-primary-700',
    outline: 'border-2 border-primary-600 bg-white text-primary-700 hover:border-primary-700 hover:bg-primary-50 hover:text-primary-800',
    ghost: 'border-2 border-primary-500 bg-transparent text-primary-700 hover:border-primary-500 hover:bg-primary-50 hover:text-primary-800'
  };
  const sizeClasses = {
    sm: 'gap-1.5 px-4 py-2 text-sm',
    md: 'gap-1.5 px-6 py-2.5 text-base',
    lg: 'gap-2 px-8 py-3 text-lg'
  };
  const widthClass = fullWidth ? 'w-full max-w-[65%]' : '';
  const shadowClass = variant === 'ghost' || variant === 'secondary' ? '' : 'shadow-sm hover:shadow-md';
  return <button ref={ref} type={type} className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${widthClass} ${shadowClass} ${className}`} onClick={onClick} data-id="element-52" data-mp="3lh8yauducu2l">
      {children}
    </button>;
});
Button.displayName = 'Button';